import { polymorphicFactory } from '@polymorphic-factory/react';
export const poly = polymorphicFactory();

export * from '@polymorphic-factory/react';
